<div class="innerexpand" *ngIf="expandDockaddress">
  <div class="">

    <div>{{PortInfo?.itiName}}</div>
    <!-- <div class="portaddress">{{PortInfo?.itiComments}}</div> -->
    <div class="portaddress">
      <a href='http://maps.google.com/?q={{PortInfo?.itiComments}}' target="_blank">
        {{PortInfo?.itiComments}}
      </a>
    </div>
  </div>
</div>